var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import React, { useEffect, useState } from "react";
import { FormSelect, FormSelectOption } from "../Select";
import { raFormDateCls } from "./Picker.less";
function FormInputDatePicker(props) {
  var initialValue = props.initialValue, onChange = props.onChange, formatMessage = props.builderProps.intl.formatMessage;
  var parsedInitialDate = initialValue ? new Date(initialValue) : null;
  var _useState = useState(parsedInitialDate && parsedInitialDate.getDate() || null), _useState2 = _slicedToArray(_useState, 2), day = _useState2[0], setDay = _useState2[1];
  var _useState3 = useState(parsedInitialDate && parsedInitialDate.getMonth() + 1 || null), _useState4 = _slicedToArray(_useState3, 2), month = _useState4[0], setMonth = _useState4[1];
  var _useState5 = useState(parsedInitialDate && parsedInitialDate.getFullYear() || null), _useState6 = _slicedToArray(_useState5, 2), year = _useState6[0], setYear = _useState6[1];
  var currentYear = (/* @__PURE__ */ new Date()).getFullYear() - 16;
  useEffect(function() {
    if (typeof onChange === "function") {
      if (day && month && year) {
        onChange("".concat(year, "-").concat(month < 10 ? "0".concat(month) : month, "-").concat(day < 10 ? "0".concat(day) : day));
      } else {
        onChange(null);
      }
    }
  }, [day, month, year, onChange]);
  return /* @__PURE__ */ React.createElement("div", {
    className: raFormDateCls
  }, /* @__PURE__ */ React.createElement(FormSelect, {
    value: day,
    placeholder: formatMessage({
      id: "common.day"
    }),
    getPopupContainer: /* @__PURE__ */ __name(function getPopupContainer(triggerNode) {
      return triggerNode.parentElement;
    }, "getPopupContainer"),
    onChange: /* @__PURE__ */ __name(function onChange2(value) {
      return setDay(value !== "-" ? value : null);
    }, "onChange")
  }, /* @__PURE__ */ React.createElement(FormSelectOption, {
    key: "-",
    value: "-"
  }, "-"), Array.apply(0, Array(31)).map(function(item, idx) {
    var value = idx + 1;
    return /* @__PURE__ */ React.createElement(FormSelectOption, {
      key: value,
      value
    }, value < 10 ? "0".concat(value) : value);
  })), /* @__PURE__ */ React.createElement(FormSelect, {
    value: month,
    placeholder: formatMessage({
      id: "common.month"
    }),
    getPopupContainer: /* @__PURE__ */ __name(function getPopupContainer(triggerNode) {
      return triggerNode.parentElement;
    }, "getPopupContainer"),
    onChange: /* @__PURE__ */ __name(function onChange2(value) {
      return setMonth(value !== "-" ? value : null);
    }, "onChange")
  }, /* @__PURE__ */ React.createElement(FormSelectOption, {
    key: "-",
    value: "-"
  }, "-"), Array.apply(0, Array(12)).map(function(item, idx) {
    var value = idx + 1;
    return /* @__PURE__ */ React.createElement(FormSelectOption, {
      key: value,
      value
    }, formatMessage({
      id: "month.".concat(value)
    }));
  })), /* @__PURE__ */ React.createElement(FormSelect, {
    value: year,
    placeholder: formatMessage({
      id: "common.year"
    }),
    getPopupContainer: /* @__PURE__ */ __name(function getPopupContainer(triggerNode) {
      return triggerNode.parentElement;
    }, "getPopupContainer"),
    onChange: /* @__PURE__ */ __name(function onChange2(value) {
      return setYear(value !== "-" ? value : null);
    }, "onChange")
  }, /* @__PURE__ */ React.createElement(FormSelectOption, {
    key: "-",
    value: "-"
  }, "-"), Array.apply(0, Array(100)).map(function(item, idx) {
    var optionValue = currentYear - idx;
    return /* @__PURE__ */ React.createElement(FormSelectOption, {
      key: optionValue,
      value: optionValue
    }, optionValue);
  })));
}
__name(FormInputDatePicker, "FormInputDatePicker");
export {
  FormInputDatePicker
};
